﻿import { Feature, MapBrowserEvent } from 'ol';
import BaseEvent from 'ol/events/Event';

import { CoordinatesResult } from '../geometries/models/CoordinateResult';

/**
 * Event emitted by a DetectBase interaction
 */
export class DetectEvent<T extends string = string> extends BaseEvent {
    constructor(
        type: T,
        public feature: Feature | undefined,
        public coordinate: CoordinatesResult | undefined,
        public mapBrowserEvent: MapBrowserEvent<UIEvent>) {
        super(type);
    }
}